import RytmWebflow from 'rytm-webflow'
import { TimelineMax, TweenMax, Elastic, Expo, Sine, Back } from 'gsap'
import { playSound, playSoundByPath } from './../amzn/sounds'

import WebflowView from './WebflowView'
import { trace } from 'rytm-helpers'

class AmznWebflowView extends WebflowView {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    const list = [...container.querySelectorAll('*[data-amznflow]')]
    list.forEach(this.showAmznElement.bind(this))
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    const list = [...container.querySelectorAll('*[data-amznflow]')]
    list.forEach(this.hideAmznElement.bind(this))
  }
  // show AMZN object
  showAmznElement(el, index) {
    switch (el.dataset.amznflow) {
      case "amznobj":
      case "essay":
        this.seqObjectMoveIn(el, index)
        break
      case "indicator":
        this.seqIndicatorMoveIn(el, index)
        break
      case "caption":
        this.seqCaptionMoveIn(el, index)
        break
      case "bodytext":
        this.seqBodyTextMoveIn(el, index)
        break
      case "carousel":
        const owlNav = el.querySelector('.owl-nav')
        this.seqCaptionMoveIn(owlNav, 1)
        break
      case "box":
        this.seqBoxMoveIn(el, index)
        break
      case "boxindicator":
        this.seqBoxIndicatorMoveIn(el, index)
        break
    }
  }
  // hide AMZN object
  hideAmznElement(el, index) {
    switch (el.dataset.amznflow) {
      case "amznobj":
      case "essay":
        this.seqObjectMoveOut(el, index)
        break
      case "indicator":
        this.seqIndicatorMoveOut(el, index)
        break
      case "caption":
        this.seqCaptionMoveOut(el, index)
        break
      case "bodytext":
        this.seqBodyTextMoveOut(el, index)
        break
      case "carousel":
        const owlNav = el.querySelector('.owl-nav')
        this.seqCaptionMoveOut(owlNav, 1)
        break
      case "box":
        this.seqBoxMoveOut(el, index)
        break
      case "boxindicator":
        this.seqBoxIndicatorMoveOut(el, index)
        break
      
    }
  }
  playAltSound(el, audioSelector, sndName) {
    // trace(el)
    const audio = el.querySelector(audioSelector)
    const audioPath = audio ? audio.getAttribute("src") : false
    if (audioPath) {
      playSoundByPath(audioPath)
    } else {
      playSound(sndName)
    }
  }

  // ### Box
  seqBoxMoveIn(el, index) {
    // playSound("cut_xl")
    this.playAltSound(el, ".audio-show", "cut_xl")
    let del = index * .05 + .3;
    del = del < 1 ? del : 1;
    let t1 = new TimelineMax({repeat: 0, onComplete: () => {
      setTimeout(() => {
        el.parentElement.classList.add("transit")
      }, 1000)
    }})
    t1.from(el, .2, {y: 100, alpha: 0, ease: Expo.easeOut, delay: del, onComplete: () => {  }})
    t1.from(el, .4, {scale: .5, ease: Expo.easeOut})
  }
  seqBoxMoveOut(el, index) {
    // playSound("cut_lg")
    this.playAltSound(el, ".audio-hide", "cut_lg")
    el.classList.remove("transit")
    let del = index * .01;
    del = del < 1 ? del : 1;
    let t1 = new TimelineMax({repeat: 0})
    t1.to(el, .3, {scale: .5, ease: Expo.easeOut, delay: del})
    t1.to(el, .2, {y: 100, alpha: 0, ease: Expo.easeOut})
  }
  // ### Box Indicator
  seqBoxIndicatorMoveIn(el, index) {
    let del = index * .05 + .5;
    del = del < 1 ? del : 1;
    TweenMax.from(el, .6, {scale: .1, ease: Expo.easeOut, delay: del})
  }
  seqBoxIndicatorMoveOut(el, index) {
    let del = index * .05;
    del = del < 1 ? del : 1;
    TweenMax.to(el, .6, {scale: .1, ease: Expo.easeOut, delay: del})
  }
  // ### Carousel
  seqCarouselMoveIn(el, index) {
    const wW = window.innerWidth
    const wH = window.innerHeight
    let t1 = new TimelineMax({repeat: 0})
    t1.from(el, .5, {y: wH, alpha: 0, ease: Expo.easeOut, delay: .5})
  }
  seqCarouselMoveOut(el, index) {
    const wW = window.innerWidth
    const wH = window.innerHeight
    let t1 = new TimelineMax({repeat: 0})
    t1.to(el, .4, {y: wH, ease: Expo.easeIn})
  }

  // ### Caption TXT
  seqCaptionMoveIn(el, index) {
    // playSound("fold_xs")
    this.playAltSound(el, ".audio-show", "fold_xs")
    TweenMax.from(el, .6, {alpha: 0, y: -10, ease: Expo.easeOut, delay: .8})
  }
  seqCaptionMoveOut(el, index) {
    // playSound("fold_xs")
    this.playAltSound(el, ".audio-hide", "fold_xs")
    TweenMax.to(el, .3, {alpha: 0, y: -10, ease: Expo.easeIn})
  }
  // ### body TXT
  seqBodyTextMoveIn(el, index) {
    let del = index * .1 + .9
    del = del < 2 ? del : 2;
    TweenMax.from(el, .6, {alpha: 0, y: 10, ease: Expo.easeOut, delay: del})
  }
  seqBodyTextMoveOut(el, index) {
    TweenMax.to(el, .3, {alpha: 0, y: 10, ease: Expo.easeIn})
  }
  // ### indicator
  seqIndicatorMoveIn(el, index) {
    const wW = window.innerWidth
    const rect = el.getBoundingClientRect()
    const moveX = wW * .5 + rect.width * .5;
    let t1 = new TimelineMax({repeat: 0})
    t1.from(el, .5, {x: moveX, ease: Expo.easeOut})
    t1.from(el, .5, {scale: .4, ease: Expo.easeOut})
  }
  seqIndicatorMoveOut(el, index) {
    const wW = window.innerWidth
    const rect = el.getBoundingClientRect()
    const moveX = wW * .5 + rect.width * .5;
    let t1 = new TimelineMax({repeat: 0})
    t1.to(el, .25, {scale: .4, ease: Expo.easeInOut, delay: .2})
    t1.to(el, .4, {x: -moveX, ease: Expo.easeIn})
  }
  // ### AMZN object
  seqObjectMoveIn(el, index) {
    // playSound("move_sm")
    this.playAltSound(el, ".audio-show", "move_sm")
    const wW = window.innerWidth
    const rect = el.getBoundingClientRect()
    const moveX = wW * .5 + rect.width * .5;
    let t1 = new TimelineMax({repeat: 0})
    t1.from(el, .5, {x: moveX, ease: Expo.easeOut, onComplete: () => { 
      // play sound only if no audio
      if (!el.querySelector(".audio-show")) {
        playSound("move_xxxs") 
      }
    }})
    t1.from(el, .5, {scale: .4, ease: Expo.easeOut})
  }
  seqObjectMoveOut(el, index) {
    // playSound("move_xxxs")
    this.playAltSound(el, ".audio-hide", "move_xxxs")
    const wW = window.innerWidth
    const rect = el.getBoundingClientRect()
    const moveX = wW * .5 + rect.width * .5;
    let t1 = new TimelineMax({repeat: 0})
    t1.to(el, .25, {scale: .4, ease: Expo.easeInOut, delay: .2, onComplete: () => { 
      // play sound only if no audio
      if (!el.querySelector(".audio-show")) {
        playSound("move_xxs") 
      }
    }})
    t1.to(el, .4, {x: -moveX, ease: Expo.easeIn})
  }

  

}

export default AmznWebflowView